// Third party libraries
import _ from "lodash";
import { ComponentProps, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Models
import GroupModel from "../../../../models/group";

// Components
import { Dropdown, DropdownProps } from "semantic-ui-react";
import { FormSelectOptionsInterface } from "../../form/select";

// Locales
import I18n from "../../../../i18n";

const GroupsFilter = (props: ComponentProps<typeof Dropdown>) => {
  const PARAM_NAME = "groupId";

  const [searchParams, setUrlSearchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);

  const groupId = searchParams.get(PARAM_NAME) || undefined;

  const [groupToAssignSelectOptions, setGroupToAssignSelectOptions] = useState<
    FormSelectOptionsInterface[]
  >([]);

  useEffect(() => {
    const getData = async () => {

      setLoading(true);

      const groups = await GroupModel.getGroups();
      const groupToAssignSelectOptions: FormSelectOptionsInterface[] = [];
      _.each(groups, (group) => {
        groupToAssignSelectOptions.push({
          key: group._id,
          text: group.name,
          value: group._id,
        });
      });

      setGroupToAssignSelectOptions(groupToAssignSelectOptions);

      setLoading(false);
    };

    getData();
  }, []);

  const onChange = (_e: any, { value }: DropdownProps) => {
    const newValue = value ? String(value) : undefined;

    // Si el valor nuevo es igual al que ya está en la URL, no hacemos nada
    if (newValue === groupId) return;

    if (!newValue) {
      searchParams.delete(PARAM_NAME);
    } else {
      searchParams.set(PARAM_NAME, newValue);
    }

    setUrlSearchParams(searchParams);
  };

  return (
    <Dropdown
      search={true}
      placeholder={I18n.t("groups.filter")}
      options={groupToAssignSelectOptions}
      value={groupId}
      selection
      fluid
      clearable
      onChange={onChange}
      loading={loading}
      selectOnBlur={false}
      selectOnNavigation={false}
      {...props}
    />
  );
};

export default GroupsFilter;
